export default {
  "dataTypes": []
}
